import {
    salesRep,
    getLicenses,
    getAllDept,
    getAllHospital,
    exportPhysician,
    updateHospitalInPhysician, exportSales
} from '../../../service/service'

export default {
    name: 'management',
    data: function () {
        return {
            total: 0,
            patientName: '',
            dateOfSurgery: '',
            keywordSearch: '',
            columns4: [
                {
                    title: this.$t('Software'),
                    key: 'software'
                }, {
                    title: this.$t('Expiration Date'),
                    slot: 'expirationdate'
                }, {
                    title: ' ',
                    width: 120,
                    slot: 'action'
                }
            ],
            data4: [],
            columns1: [
                {
                    title: this.$t('name'),
                    key: 'name'
                }, {
                    title: this.$t('email'),
                    key: 'email'
                }, {
                    title: this.$t('phone number'),
                    key: 'phonenumber'
                }, {
                    title: this.$t('admin'),
                    slot: 'admin'
                }
            ],
            data1: [],
            searchMark: false,
            timeoutId: '',
            modal: false,
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            modal5: false,
            modal6: false,
            modal7: false,
            modal8: false,
            modal9: false,
            modal10: false,
            modal11: false,
            resetname: '',
            txtComment: '',
            formItem: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false
            },
            note: '',
            ruleInline: {
                patientname: [
                    {required: true, message: this.$t('Please fill in the patient name'), trigger: 'blur'}
                ],
                hospital: [
                    {required: true, message: this.$t('Please select the hospital'), trigger: 'change'}
                ],
                priority: [
                    {required: true, message: this.$t('Please select at priority'), trigger: 'change', type: 'boolean'}
                ]
            },
            modalNext: false,
            fileList: [],
            showTable: '',
            columns2: [
                {
                    title: this.$t('physician'),
                    key: 'physician',tooltip:true
                }, {
                    title: this.$t('specialty'),
                    key: 'specialty',tooltip:true
                }, {
                    title: this.$t('email'),
                    key: 'email',
                    width: 250,tooltip:true
                }, {
                    title: this.$t('phone number'),
                    key: 'phoneNumber',
                tooltip:true
                }, {
                    title: this.$t('hospital'),
                    minWidth: 100,
                    key: 'hospital',tooltip:true
                }, {
                    title: this.$t('total customcases'),
                    key: 'totalCustomCases',tooltip:true
                }, {
                    title: this.$t('total automatic cases'),
                    key: 'totalAutomaticCases',tooltip:true
                }, {
                    title: this.$t('admin'),
                    slot: 'admin'
                }
            ],
            data2: [],
            modalName: '',
            modalPhone: '',
            oldEmailLogin: '',
            newEmailLogin: '',
            software: '',
            software1: '',
            expirationDate: '',
            expirationDate1: '',
            newName: '',
            newEmail: '',
            role: '',
            surgery: '',
            pagesize: 20,
            pageTo: "1",
            row: {},
            myName: 'Mira Liu',
            myCompany: 'Orthopedics',
            hospitalInputList: [
                {hospitalId: ''}
            ],
            specialtylList: [],
            page: 1,
            licenseRow: null,
            hospitalList: [],
            chooseRow: [{'caseId': 'caseId'}],
            licensesList: [],
            emailRe: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
            newPhone: '',
            editPhone: '',
            countryCode: '+1',
            currentUserId: ''
        }
    },
    methods: {
        displayPhone1() {
            this.editPhone = this.editPhone.replace(/\D/g, '');
            // console.log(this.newPhone)
        },
        displayPhone() {
            this.newPhone = this.newPhone.replace(/\D/g, '');
            // console.log(this.newPhone)
        },
        toCsv() {
            console.log(JSON.stringify(this.chooseRow))
            exportPhysician({
                "UserID": this.token,
                "type": "sales",
                "keywordSearch": this.keywordSearch,
            })
        },
        rowClass(row) {
            if (row._isHighlight) {
                // console.log(row)
                return "row-class"
            }
        },
        onSelectRow(row, index) {
            // console.log(this.$refs.tableJin.objData[index])
            // console.log(selection)
            if (!this.$refs.tableJin.objData[index]._isHighlight) {
                this.$refs.tableJin.objData[index]._isHighlight = true
                let obj = {
                    doctorId: row.docId
                }
                this.chooseRow.push(obj)
            } else {
                this.chooseRow.forEach((e, i) => {
                    if (row.id === e.id) {
                        this.chooseRow.splice(i, 1)
                    }
                })
                this.$refs.tableJin.objData[index]._isHighlight = false
            }
        },
        goPage() {
            if (this.pageTo) {
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if (parseInt(this.pageTo) > maxPage) {
                    this.page = maxPage
                } else {
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            } else {
                this.pageTo = this.page
            }
        },
        reloadView() {
            let obj = {
                "UserID": this.token,
                "keywordSearch": this.keywordSearch,
                "page": this.page,
                "limit": this.pagesize,
                "tableName": this.showTable
            }
            salesRep.management.getManagementData(obj).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    console.log(res.data)
                    this.$Spin.hide();
                    // console.log(this.showTable)
                    if (this.showTable === 'sales-representative') {
                        let data = JSON.parse(res.data)
                        this.data1 = data
                        this.total = data.length
                    } else {
                        this.data2 = res.data[0]
                        this.total = res.data[0].length
                        // this.hospitalInputList = res.data[0].hospital.split(',')
                        // console.log(res.data[0])
                    }
                    // console.log(JSON.parse(data.list))

                }
            })
        },
        delHospital(index) {
            this.hospitalInputList.splice(index, 1)
        },
        addHospital() {
            if (this.hospitalInputList.length < 10) {
                let obj = {
                    hospitalId: ''
                }
                this.hospitalInputList.push(obj)
            }
            // let arr = hospitalInputList
            // arr.push(obj)
            // this.hospitalInputList = arr
        },
        changePage(e) {
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        sel(row, e) {
            console.log(row)
            this.row = row
            console.log(e)
            if (e === 'edit') {
                if (this.showTable === 'sales-representative') {
                    this.modal1 = true
                } else {
                    let aa = this.row.phoneNumber.indexOf('+1 ')
                    // let aa = str.indexOf('+1 ')
                    let str1 = ''
                    let str2 = ''
                    if (aa === 0) {
                        str1 = this.row.phoneNumber.substr(3)
                        str2 = this.row.phoneNumber.substr(0, 2)

                    } else if (aa === -1) {
                        str1 = this.row.phoneNumber.substr(4)
                        str2 = this.row.phoneNumber.substr(0, 3)
                    }
                    this.editPhone = str1
                    this.countryCode = str2

                    this.modal8 = true
                    this.surgery = row.specialty
                    let arrNew = []
                    let arrHos = this.row.hospital.split(',')
                    arrHos.forEach(i => {
                        this.hospitalList.forEach(k => {
                            if (i != '' && i === k.hospitalName) {
                                let obj = {
                                    hospitalId: k.hospitalId
                                }
                                arrNew.push(obj)
                            }
                        })
                    })
                    this.hospitalInputList = arrNew
                }
            } else if (e === 'change') {
                this.modal2 = true
            } else if (e === 'manage') {
                let p = {
                    // token: this.token,
                    UserUID: this.token
                }
                if (this.showTable === 'sales-representative') {
                    p.userId = this.row.SalesId
                } else {
                    p.userId = this.row.docId
                }
                this.currentUserId = p.userId;
                this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                'class': 'demo-spin-icon-load',
                                props: {
                                    type: 'ios-loading',
                                    color: '#f48221',
                                    size: 18
                                }
                            }),
                            h('div', {
                                style: {
                                    color: '#f48221'
                                },
                            }, 'Loading')
                        ])
                    }
                });

                salesRep.management.manageSoftwareLicenses({id: p.userId}).then(res => {
                    let code = parseInt(res.code)
                    this.$Spin.hide()
                    if (!code) {
                        console.log(res.data)
                        if (res.data) {
                            var data = JSON.parse(res.data)
                        }
                        this.data4 = data
                    }
                })
                getLicenses({UserUID: p.userId}).then(res => {
                    let code = parseInt(res.code)
                    if (!code) {
                        this.licensesList = res.Licenses;
                    }
                })
                this.modal4 = true
            } else {
                this.row = row
                this.modal9 = true
                this.resetname = this.row.physician
            }
        },
        inviteUser() {
            if (this.showTable === 'sales-representative') {
                this.modal7 = true
            } else {
                this.modal6 = true
                this.hospitalInputList = [];
            }
        },
        ok10() {
            this.modal10 = false
        },
        ok9() {
            let id = ''
            let role = '';
            if (this.showTable === 'sales-representative') {
                id = this.row.SalesId
                role = 'sales-representative'
            } else {
                id = this.row.docId
                role = 'physician'
            }
            salesRep.management.resetPassword({
                userId: this.token,
                id: id,
                role: role
            }).then(res => {
                if (res.code === '0') {
                    this.$Message.success("A link to reset the password has been sent to this user's email.")
                    this.reloadView()
                } else if (res.code === '-100') {
                    this.$Message.error('Operation without permission !')
                }
            })
            this.modal9 = false
        },
        cancel9() {
            this.modal9 = false
        },
        ok8() {
            let hosStr = ''
            this.hospitalInputList.forEach((i) => {
                hosStr = hosStr + i.hospitalId + ','
            })
            if (hosStr === '') {
                this.$Message.error('Hospital cannot be empty')
                return
            }
            console.log(this.hospitalInputList)
            let p = {
                "tableName": this.showTable,
                "userId":this.token,
                "id": this.row.docId,
                "name": this.row.physician,
                "phoneNumber": this.countryCode + ' ' + this.editPhone,
                "specialty": this.surgery,
            }
            // console.log(p)

            // return;
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.management.editInfo(p).then(res => {
                console.log(res)
                this.$Spin.hide()
                let code = parseInt(res.code)
                if (!code) {
                    updateHospitalInPhysician({
                        userId: this.token,
                        doctorId: this.row.docId,
                        hospitalId: hosStr
                    }).then(res => {
                        console.log(res)
                        this.reloadView()
                        this.hospitalInputList = []
                        this.surgery = ''
                        this.countryCode = '+1'
                    })
                    this.modal8 = false
                } else if (res.code === '-100') {
                    this.$Message.error('Operation without permission !')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel8() {
            this.modal8 = false
            this.hospitalInputList = []
            this.surgery = ''
        },
        ok7() {
            this.modal10 = true
            this.modal7 = false
        },
        cancel7() {
            this.modal7 = false
        },
        ok6() {
            let hosStr = ''
            this.hospitalInputList.forEach((i) => {
                if (i.hospitalId != '') {
                    hosStr = hosStr + i.hospitalId + ','
                }
            })
            if (hosStr === '') {
                this.$Message.error('Hospital cannot be empty')
                return
            }
            if (this.showTable === '') {
                this.$Message.error('Role cannot be empty')
                return
            }
            if (this.newName === '') {
                this.$Message.error('Name cannot be empty')
                return
            }
            if (this.surgery === '') {
                this.$Message.error('Specialty cannot be empty')
                return
            }
            if (this.newEmail === '') {
                this.$Message.error('Email cannot be empty')
                return
            }
            if (this.emailRe.test(this.newEmail)) {
                this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                'class': 'demo-spin-icon-load',
                                props: {
                                    type: 'ios-loading',
                                    color: '#f48221',
                                    size: 18
                                }
                            }),
                            h('div', {
                                style: {
                                    color: '#f48221'
                                },
                            }, 'Loading')
                        ])
                    }
                });
                salesRep.management.inviteNewUser({
                    "role": this.showTable,
                    "name": this.newName,
                    "email": this.newEmail,
                    'specialty': this.surgery,
                    'phoneNumber': this.countryCode + ' ' + this.newPhone,
                    'id': this.token
                }).then(res => {
                    // console.log(res)
                    this.$Spin.hide()
                    let code = parseInt(res.code)
                    if (!code) {
                        this.modal10 = true
                        this.modal6 = false
                        updateHospitalInPhysician({
                            userId: this.token,
                            doctorId: res.data,
                            hospitalId: hosStr
                        }).then(res => {
                            console.log(res)
                            this.reloadView()
                            this.surgery = ''
                            this.hospitalInputList = []
                            this.newName = ''
                            this.newEmail = ''
                            this.newPhone = ''
                            this.countryCode = '+1'
                        })
                        // this.$Message.success('Invitation sent')
                    } else if (res.code === '-100') {
                        this.$Message.error('Operation without permission !')
                    } else {
                        if (res.msg === '') {
                            this.$Message.warning(this.$t('fail'))
                        } else {
                            this.$Message.warning(this.$t(res.msg))
                        }
                    }
                })
            } else {
                this.$Message.warning(this.$t('Invalid email address'))
            }
        },
        cancel6() {
            this.newName = ''
            this.newEmail = ''
            this.newPhone = ''
            this.modal6 = false
            this.hospitalInputList = []
            this.surgery = ''
        },
        dateChange1(e) {
            this.expirationDate1 = e
        },
        dateChange(e) {
            this.expirationDate = e
        },
        addLicenses() {
            this.modal5 = true
        },
        delLicenses(row) {
            let p = {
                "id": row.softwareId,
                "userid": this.row.SalesId
            }
            if (this.showTable === 'sales-representative') {
                p.userid = this.row.SalesId
            } else {
                p.userid = this.row.docId
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.management.delSoftwareLicenses(p).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide()
                if (!code) {
                    salesRep.management.manageSoftwareLicenses({id: p.userid}).then(res => {
                        let code = parseInt(res.code)
                        if (!code) {
                            console.log(res.data)
                            if (res.data) {
                                var data = JSON.parse(res.data)
                            }
                            this.data4 = data
                        }
                    })
                    this.reloadView()
                } else if (res.code === '-100') {
                    this.$Message.error('Operation without permission !')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        editLicenses(row) {
            console.log(row.expirationDate + "asas")
            this.modal11 = true
            this.licenseRow = row
            this.expirationDate1 = this.licenseRow.expirationDate;
        },
        ok11() {
            let p = {
                "softwareId": this.licenseRow.softwareId,
                "expirationDate": this.expirationDate1,
                "userId": this.token,
                'userid': this.currentUserId
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.management.editSoftwareLicenses(p).then(res => {
                console.log(res)
                this.$Spin.hide()
                if (res.code === '0') {
                    this.modal5 = false
                    let p = {
                        token: this.token
                    }
                    if (this.showTable === 'sales-representative') {
                        p.UserUID = this.row.SalesId
                    } else {
                        p.UserUID = this.row.docId
                    }
                    this.modal11 = false;
                    this.expirationDate1 = '';
                    this.software1 = '';
                    salesRep.management.manageSoftwareLicenses({id: p.UserUID}).then(res => {
                        let code = parseInt(res.code)
                        this.$Spin.hide()
                        if (!code) {
                            console.log(res.data)
                            if (res.data) {
                                var data = JSON.parse(res.data)
                            }
                            this.data4 = data
                        }
                    })
                } else if (res.code === '-100') {
                    this.$Message.error('Operation without permission !')
                } else {
                    this.$Message.error('Operation without permission !')
                }
            })
        },
        cancel11() {
            this.modal11 = false
        },
        ok5() {
            let p = {
                "softId": this.software,
                "expirationDate": this.expirationDate,
                "userid": this.token
            }
            if (this.showTable === 'sales-representative') {
                p.id = this.row.SalesId
            } else {
                p.id = this.row.docId
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.management.addSoftwareLicenses(p).then(res => {
                console.log(res)
                this.$Spin.hide()
                if (res.code === '0') {
                    this.modal5 = false
                    let p = {
                        token: this.token
                    }
                    if (this.showTable === 'sales-representative') {
                        p.UserUID = this.row.SalesId
                    } else {
                        p.UserUID = this.row.docId
                    }
                    this.$Spin.show({
                        render: (h) => {
                            return h('div', [
                                h('Icon', {
                                    'class': 'demo-spin-icon-load',
                                    props: {
                                        type: 'ios-loading',
                                        color: '#f48221',
                                        size: 18
                                    }
                                }),
                                h('div', {
                                    style: {
                                        color: '#f48221'
                                    },
                                }, 'Loading')
                            ])
                        }
                    });
                    salesRep.management.manageSoftwareLicenses({id: p.UserUID}).then(res => {
                        let code = parseInt(res.code)
                        this.$Spin.hide()
                        if (!code) {
                            console.log(res.data)
                            if (res.data) {
                                var data = JSON.parse(res.data)
                            }
                            this.data4 = data
                        }
                    })
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel5() {
            this.modal5 = false
        },
        ok4() {
            this.modal4 = false
        },
        cancel4() {
            this.modal4 = false
        },
        ok3() {
            this.modal3 = false
        },
        ok2() {
            if (this.emailRe.test(this.newEmailLogin)) {
                let p = {
                    userId: this.token,
                    "role": this.showTable,
                    "newEmailLogin": this.newEmailLogin
                }
                if (this.showTable === 'sales-representative') {
                    p.id = this.row.SalesId
                } else {
                    p.id = this.row.docId
                }
                this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                'class': 'demo-spin-icon-load',
                                props: {
                                    type: 'ios-loading',
                                    color: '#f48221',
                                    size: 18
                                }
                            }),
                            h('div', {
                                style: {
                                    color: '#f48221'
                                },
                            }, 'Loading')
                        ])
                    }
                });
                salesRep.management.changeEmailLogin(p).then(res => {
                    // console.log(res)
                    this.$Spin.hide()
                    let code = parseInt(res.code)
                    if (!code) {
                        this.modal2 = false
                        this.newEmailLogin = ''
                        this.reloadView()
                    } else if (res.code === '-100') {
                        this.$Message.error('Operation without permission !')
                    } else {
                        if (res.msg === '') {
                            this.$Message.warning(this.$t('fail'))
                        } else {
                            this.$Message.warning(this.$t(res.msg))
                        }
                    }
                })
            } else {
                this.$Message.warning(this.$t('Invalid email address'))
            }
        },
        cancel2() {
            this.modal2 = false
        },
        ok1() {
            this.modal3 = true
            this.modal1 = false
        },
        cancel1() {
            this.modal1 = false
        },
        fileAdded(file) {
            console.log(file, 1)
        },
        delFile(i) {
            this.fileList.splice(i, 1)
        },
        handleUpload(file) {
            console.log(file)
            let arr = this.fileList;
            arr.push(file)
            this.fileList = arr

            return false;
        },
        back() {
            this.modalNext = false
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$Message.success('Success!');
                    this.modalNext = true
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        ok() {
            this.modal = false
            this.modalNext = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
        cancel() {
            this.modal = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
        addCase() {
            this.modal = true
        },
        download(row, index) {
            console.log(row)
            console.log(index)
        },
        changePageSize(size) {
            this.page = 1
            this.pageTo = 1
            this.pagesize = size
            this.reloadView()
        },
        showDate() {
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        navClick(type) {
            this.showTable = type
            sessionStorage.setItem('showTable', type)
            this.reloadView()
        }
    },
    destroyed() {
        sessionStorage.removeItem('showTable')
    },
    created() {

    },
    mounted() {
        this.showTable = sessionStorage.getItem('showTable') || 'physician'
        this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
        getAllDept({UserUID: this.token}).then(res => {
            this.specialtylList = res.Dept
        })
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color: '#f48221',
                            size: 18
                        }
                    }),
                    h('div', {
                        style: {
                            color: '#f48221'
                        },
                    }, 'Loading')
                ])
            }
        });
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.management-modal').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal5').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function () {
            // eslint-disable-next-line no-irregular-whitespace
            // console.log(h/1920 * 100 + '%')
            document.querySelectorAll('.custom-modal-details').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal-case').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
        }
        getAllHospital({UserUID: this.token}).then(res => {
            let code = parseInt(res.code)
            if (!code) {
                let hosList = JSON.parse(res.data)
                console.log(hosList)
                this.hospitalList = hosList
            }
        })
        this.reloadView()
    }
}
